import { render } from "./AdminTemplateEvent.vue?vue&type=template&id=63a07630&scoped=true"
import script from "./AdminTemplateEvent.vue?vue&type=script&lang=js"
export * from "./AdminTemplateEvent.vue?vue&type=script&lang=js"

import "./AdminTemplateEvent.vue?vue&type=style&index=0&id=63a07630&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a07630"]])

export default __exports__